import { render } from "./PlaylistCardSkeleton.vue?vue&type=template&id=fce6f35c&scoped=true"
const script = {}

import "./PlaylistCardSkeleton.vue?vue&type=style&index=0&id=fce6f35c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fce6f35c"]])

export default __exports__